import { useState } from 'react';
import axios from 'axios';
import { apiKey, apiUrl } from '../lib/config';

export const useApiPost = (url, token = null) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [responseData, setResponseData] = useState(null);

  const postData = async (payload) => {
    setLoading(true);
    setError(null);

    try {
      let apiKeyTxt = apiKey;
      let apiUrlTxt = apiUrl + url;

      const isFormData = payload instanceof FormData;

      const headers = {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...(apiKeyTxt && { 'x-api-key': apiKeyTxt }),
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      };

      const response = await axios.post(apiUrlTxt, payload, { headers });

      setResponseData(response.data);
      return { result: response.data, error: null };
    } catch (err) {
      let errorMsg = err?.response?.data?.message || err?.message || "Something went wrong";
      setError(errorMsg);
      return { result: null, error: errorMsg };
    } finally {
      setLoading(false);
    }
  };

  return { postData, loading, error, responseData };
};
